import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import App from "./App";
import AuthErrorPage from "@/components/AuthErrorPage";
import { ThemeProvider } from "@/hooks/useTheme";
import i18n, { loadLocaleMessages } from "@/app/i18n";
import { ensureAuthenticated, NotTelegramEnvironmentError } from "@/api/auth.api";
import { getActiveHost } from "@/hosts";
import { resolveAndPersistStartupLang } from "@/lib/env";
import "./app/globals.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

const savedLang = resolveAndPersistStartupLang();

Promise.all([
  loadLocaleMessages(savedLang),
  ensureAuthenticated(),
])
  .then(() => {
    // `pagehide` reload da ham ishga tushadi (persisted=false) — shuning uchun
    // navigation type ni tekshiramiz: faqat tab/window yopilganda logout bo'lsin,
    // reload va boshqa navigatsiyalarda emas.
    window.addEventListener("pagehide", (event) => {
      if (event.persisted) return; // bfcache ga o'tdi — logout kerak emas
      const navType = (performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming | undefined)?.type;
      // "reload" yoki "navigate" (ichki navigatsiya) bo'lsa — skip
      if (navType === "reload" || navType === "navigate") return;
      getActiveHost().logout?.();
    });
    
    createRoot(root).render(
      <StrictMode>
        <I18nextProvider i18n={i18n}>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </I18nextProvider>
      </StrictMode>
    );
  })
  .catch((err) => {
    if (err instanceof NotTelegramEnvironmentError) {
      root.innerHTML = `
        <div style="
          min-height: 100dvh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 20px;
          padding: 32px 24px;
          text-align: center;
          background: #000000;
          font-family: Inter, ui-sans-serif, system-ui, sans-serif;
        ">
          <div style="
            width: 72px; height: 72px;
            border-radius: 50%;
            background: rgba(242,88,34,0.14);
            display: flex; align-items: center; justify-content: center;
          ">
            <svg width="36" height="36" fill="none" viewBox="0 0 24 24" stroke="#f25822" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
            </svg>
          </div>
          <div>
            <p style="margin: 0 0 8px; font-size: 18px; font-weight: 800; color: #f8f8f7;">
              Telegram orqali oching
            </p>
            <p style="margin: 0; font-size: 14px; color: #c1beb3; line-height: 1.6;">
              Ushbu ilova faqat <strong style="color: #f25822;">Telegram</strong> orqali ishlatilishi mumkin.<br>
              Iltimos, botni Telegram'da oching.
            </p>
          </div>
          <a
            href="https://t.me/ihma1070bot"
            style="
              display: inline-block;
              margin-top: 8px;
              padding: 14px 32px;
              border-radius: 16px;
              background: #f25822;
              color: #ffffff;
              font-size: 15px;
              font-weight: 700;
              text-decoration: none;
            "
          >
            Telegram'da ochish
          </a>
        </div>
      `;
      return;
    }

    // Boshqa barcha auth xatolari (ApiError, network error va h.k.)
    // globals.css allaqachon yuklangan — CSS tokenlar ishlaydi
    createRoot(root).render(
      <StrictMode>
        <AuthErrorPage error={err} />
      </StrictMode>
    );
  });
